import { Typography } from '@mui/material';
import React from 'react';
import AttachmentCard from '../attachmentCard/AttachmentCard';
import LoadingBackdrop from 'components/LoadingBackdrop';
import { DeleteFile } from 'api/canguard/deleteFile';
import { useNotificationProvider } from 'hooks';
import { useActivePatrolData } from '../../context/activePatrol/ActivePatrolDataProvider';

interface PatrolAttachmentsProps {
	// Define your props here
}

const PatrolAttachments: React.FC<PatrolAttachmentsProps> = (props) => {
	// Add your component logic here
	const { patrolAttachments, handlePatrolAttachmentsUpdate } =
		useActivePatrolData();
	const [pendingDelete, setPendingDelete] = React.useState<boolean>(false);
	const { notifySuccess, notifyError } = useNotificationProvider();

	const deleteAttachment = async (fileIDToDelete: number | string) => {
		// CANcam videos cannot be deleted from here
		const attachment = patrolAttachments.find(a => a.AttachmentID === fileIDToDelete);
		if (attachment?.Source === 'cancam') {
			notifyError('CANcam videos cannot be deleted from patrol attachments');
			return;
		}

		setPendingDelete(true);
		try {
			await DeleteFile(fileIDToDelete as number);

			const updatedAttachments = patrolAttachments.filter(
				(item) => item.AttachmentID !== fileIDToDelete,
			);
			handlePatrolAttachmentsUpdate(updatedAttachments);
			notifySuccess('File deleted successfully');
		} catch (e) {
			console.error('Error in file deletion: ', e);
			notifyError('Error deleting file');
		} finally {
			setPendingDelete(false);
		}
	};

	return (
		<>
			{patrolAttachments.length === 0 && (
				<Typography
					textAlign={'center'}
					variant="body1"
					color={'warning.main'}
					fontStyle={'italic'}
				>
					No attachments uploaded
				</Typography>
			)}
			{patrolAttachments.map((attachment, index) => (
				<AttachmentCard
					key={attachment.AttachmentID}
					contentType={attachment.ContentType}
					name={attachment.Name}
					id={attachment.AttachmentID}
					size={attachment.Size}
					index={index}
					source={attachment.Source}
					onConfirmDelete={(id) => deleteAttachment(id)}
					disableDelete={attachment.Source === 'cancam'}
				/>
			))}
			<LoadingBackdrop open={pendingDelete} />
		</>
	);
};

export default PatrolAttachments;
